import { object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  clientId: string().required(),
  groupId: string().required(),
})

export const url = ({ clientId, groupId }) => `/v1/clients/${clientId}/groups/${groupId}/services`
